<template>
  <div>
    <b-card class="mb-2" bg-variant="dark" border-variant="danger">
      <b-card-header header-bg-variant="secondary"><h5>Recording Archive</h5></b-card-header>
      <div id="loadingDiv" class="text-center" style="padding-top: 5px" v-if="!recordingStatusLoaded">
        <b-spinner label="Loading..." variant="danger"/>
      </div>
      <div id="recordingContentDiv" v-if="recordingStatusLoaded">
        <b-card-text>Recordings are currently: {{ recordS3Status }}</b-card-text>
        <div id="onlineDiv" v-if="recordS3Status === 'Online'">

          <b-card-text>Current number of files available: {{ recordingCount }}</b-card-text>
          <b-card-text>Total size of all files: {{ recordingSize }} MB</b-card-text>
          <b-button id="browseRecordings" @click="browseRecordings" variant="outline-danger">View the recordings
          </b-button>
        </div>
        <div id="offlineDiv" v-if="recordS3Status === 'Offline'">
          <b-card-text>If this message persists please contact the administrators.</b-card-text>
        </div>
      </div>
    </b-card>
    <b-modal id="bucketBrowserModal"
             title="Recording Archive"
             v-model="recordingModalShow"
             header-bg-variant="secondary"
             header-class="default-color"
             body-bg-variant='dark'
             hide-footer
             footer-bg-variant="dark">
      <RecordingBucketBrowser v-bind:recording-bucket-data="this.recordingBucketData">

      </RecordingBucketBrowser>
    </b-modal>
  </div>
</template>

<script>
  import { Auth, Storage } from 'aws-amplify'
  import RecordingBucketBrowser from './RecordingBucketBrowser'

  export default {
    name: 'RecordingCard',
    components: { RecordingBucketBrowser },
    data () {
      return {
        recordingStatusLoaded: false,
        recordS3Status: 'Offline',
        recordingCount: 0,
        recordingSize: 0,
        recordingBucketData: '',
        recordingModalShow: false
      }
    },
    created () {
      this.getRecordingS3Contents()
    },

    methods: {
      async getRecordingS3Contents () {
        Auth.currentUserCredentials().then(creds => {
          Storage.list('', { level: 'public' })
            .then(result => {
              let recordingBytes = 0
              result.forEach(item => {
                if (item.size > 0) {
                  recordingBytes += item.size
                  this.recordingCount++
                }
              })
              if (this.recordingCount > 0) {
                this.recordS3Status = 'Online'
                this.recordingSize = (recordingBytes / 1048576).toFixed(2)
                this.recordingBucketData = result
              }
              this.recordingStatusLoaded = true
            })
            .catch(err => console.log(err))
        })
      },
      browseRecordings () {
        this.recordingModalShow = true
      }
    }
  }

</script>
